import Sortable from 'sortablejs';
import Rails from '@rails/ujs';

const initSortableList = () => {
  const elements = document.querySelectorAll('.sortable');
  elements.forEach((el) => {
    Sortable.create(el, {
      handle: '.move-handle',
      draggable: '.draggable',
      animation: 150,
      onEnd(evt) {
        const newPosition = evt.newDraggableIndex;
        const moveUrl = evt.item.dataset.url;
        const formData = new FormData();

        formData.append('position', newPosition + 1);
        Rails.ajax({
          url: moveUrl,
          type: 'put',
          data: formData,
        });
      },
    });
  });
};

export { initSortableList };
